import type { ComponentProps, FC } from 'react';
import { useNavigate } from 'react-router';

import { ButtonRow } from '../../components/global/ButtonRow/ButtonRow';
import { FlowStepWithContainer } from '../../components/layout/FlowStepWithContainer';
import { WhereAndWhereForm } from '../../forms/event/WhereAndWhen/WhereAndWhenForm.tsx';
import { getCurrentStepInfo, getNextStep } from './eventOnboardingFlow.ts';
import { useOnboardingIncompleteEvent } from './hooks/useOnboardingIncompleteEvent.ts';

export const EventWhereAndWhen: FC = () => {
  const navigate = useNavigate();
  const currentStep = 'where-when';
  const { currentStep: stepNumber, totalSteps, label: heading } = getCurrentStepInfo(currentStep);

  const { query, mutation } = useOnboardingIncompleteEvent({
    onMutationSuccess: () => void navigate(`../${getNextStep(currentStep)}`),
  });

  const onSubmit: ComponentProps<typeof WhereAndWhereForm>['onSubmit'] = ({
    recurrenceAmount,
    recurrenceDurationOption,
    recurrenceMonthType,
    recurrenceRate,
    recurrenceActive,
    start,
    end,
    eventType,
    venue,
    customVenue,
    onlineLink,
  }) => {
    mutation.mutate({
      recurrenceAmount,
      recurrenceDurationOption,
      recurrenceMonthType,
      recurrenceRate,
      recurrenceActive,
      start,
      end,
      eventType,
      venue,
      customVenue,
      onlineLink,
    });
  };

  if (!query.data) {
    return null;
  }

  return (
    <FlowStepWithContainer
      bodyContent={
        <WhereAndWhereForm
          buttonSlot={
            <ButtonRow
              primaryButton={{
                type: 'submit',
                text: 'Next',
                isPending: mutation.isPending,
              }}
              secondaryButton={{
                text: 'Back',
                onClick: () => void navigate(-1),
              }}
            />
          }
          defaultValues={query.data}
          onSubmit={onSubmit}
        />
      }
      heading={heading}
      progress={{ currentStep: stepNumber, totalSteps }}
    />
  );
};
